import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RenamePdfMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type RenamePdfMutation = { __typename: 'PharosMutations', pdf_Update: { __typename: 'pdfPayload', object: { __typename: 'PdfType', id: string, name: string } | null } | null };


export const RenamePdfDocument = gql`
    mutation renamePdf($id: ID!, $name: String!) {
  pdf_Update(input: {id: $id, name: $name}) {
    object {
      id
      name
    }
  }
}
    `;
export type RenamePdfMutationFn = Apollo.MutationFunction<RenamePdfMutation, RenamePdfMutationVariables>;

/**
 * __useRenamePdfMutation__
 *
 * To run a mutation, you first call `useRenamePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenamePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renamePdfMutation, { data, loading, error }] = useRenamePdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenamePdfMutation(baseOptions?: Apollo.MutationHookOptions<RenamePdfMutation, RenamePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenamePdfMutation, RenamePdfMutationVariables>(RenamePdfDocument, options);
      }
export type RenamePdfMutationHookResult = ReturnType<typeof useRenamePdfMutation>;
export type RenamePdfMutationResult = Apollo.MutationResult<RenamePdfMutation>;
export type RenamePdfMutationOptions = Apollo.BaseMutationOptions<RenamePdfMutation, RenamePdfMutationVariables>;